import axios from '@/util/basehttp';
import qs from 'qs';
const pre = "/sys/menuRole"
const sysMenuRole = {
  saveMenuRole(nodes, roleId) {
    return axios.post(pre+"/saveMenuRole", qs.stringify({
      nodes: nodes,
      roleId: roleId,
    }));
  },
}
export default sysMenuRole;



// WEBPACK FOOTER //
// ./src/api/sys/menuRole.js